import { createTheme } from '@material-ui/core/styles';
import { StyledTheme } from './styleTheme';

export const theme = createTheme({
  palette: {
    primary: {
      main: StyledTheme.tealDark,
      contrastText: StyledTheme.white,
    },
    secondary: {
      main: StyledTheme.tealDark,
      contrastText: StyledTheme.white,
    },
  },
  typography: {
    fontFamily: StyledTheme.fontProximaNova,
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        '&$containedPrimary': {
          backgroundColor: StyledTheme.tealDark,
          color: StyledTheme.white,
          '&:hover': {
            backgroundColor: '#237c96',
            textDecoration: 'none',
            cursor: 'pointer',
          },
        },
      },
      containedPrimary: {},
    },
    MuiChip: {
      outlinedPrimary: {
        color: `${StyledTheme.tealDark} !important`,
        borderColor: `${StyledTheme.tealDark} !important`,
      },
      colorPrimary: {
        backgroundColor: `${StyledTheme.tealDark} !important`,
        color: `${StyledTheme.white} !important`,
      },
    },
  },
});
